import { render, staticRenderFns } from "./ExportableSettlementBreakdown.vue?vue&type=template&id=83237cda&"
import script from "./ExportableSettlementBreakdown.vue?vue&type=script&lang=js&"
export * from "./ExportableSettlementBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ExportableSettlementBreakdown.vue?vue&type=style&index=0&id=83237cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports